<template lang="pug">
div
  TopicBlock(
    :name="topic.creator.internal_name_short",
    :created-at="topic.created_at",
    :text="topic.text",
    :avatar-data="avatarData",
    :profile-url="topic.creator.url"
    :attachments="topic.attachments"
  )
  TopicFooter(
    :topic="topic",
    :posts-count="totalPostsCount",
    :can-react="canCreateReactions",
    :can-post="canCreatePosts",
    :viewContext="viewContext"
  )
  CommentList(
    v-if="commentList.length > 0",
    :comments="commentList",
    :comments-count="commentsCount",
    @delete="handleDeleteComment"
    :viewContext="viewContext"
  )
</template>

<script lang="ts">
import { ref, Ref, computed, defineComponent, PropType, watch } from "vue"
import { IAvatar } from "../../interfaces/avatar.interface"
import { Topic } from "suus-api"
import useDeleteComment from "../../concerns/useDeleteComment"

import TopicBlock from "./TopicBlock.vue"
import TopicFooter from "./TopicFooter.vue"

import CommentList from "../Comment/CommentList.vue"
import { getContextName } from "concerns/useContextName"
import { MemberReaction } from "components/ReactionCount/reaction-count.types"

export default defineComponent({
  name: "Topic",
  components: { TopicBlock, TopicFooter, CommentList },
  props: {
    topic: { type: Object as PropType<Topic>, required: true },
    totalPostsCount: { type: Number, default: 0 },
    canCreatePosts: { type: Boolean, default: false },
    canCreateReactions: { type: Boolean, default: false },
    topicReactions: { type: Array, default: () => [] },
  },
  setup(props, context) {
    const avatarData: Ref<IAvatar> = computed(() => {
      return {
        name: props.topic.creator.internal_name_short,
        imageUrl: props.topic.creator.avatar_url,
        profileUrl: props.topic.creator.url,
        clients: props.topic.creator.clients,
      }
    })
    const commentList = ref(props.topic.comments)
    const commentsCount = ref(props.topic.comments_count)
    watch(
      () => props.topic,
      (newVal) => {
        commentList.value = newVal.comments
        commentsCount.value = newVal.comments_count
      }
    )

    function handleDeleteComment(commentId: number): void {
      const { isSuccess } = useDeleteComment(commentId.toString())
      watch(isSuccess, (isSuccessValue: boolean) => {
        if (isSuccessValue) {
          const _comments = commentList.value.filter(
            (comment) => comment.id !== commentId
          )
          commentList.value = _comments
          commentsCount.value--
          console.log(commentList.value)
          console.log(commentsCount.value)
        }
      })
    }

    const viewContext = { group: props.topic.group }

    const memberReactions = ref<MemberReaction[]>([])
    watch(
      () => props.topicReactions,
      (newVal) => {
        memberReactions.value = newVal.map((reaction: any) =>
          MemberReaction.fromReaction(reaction, viewContext)
        )
      }
    )

    return {
      viewContext,
      avatarData,
      handleDeleteComment,
      commentList,
      commentsCount,
      memberReactions,
    }
  },
})
</script>
